<template>
  <div>
    <el-row type="flex">
      <!-- 템플릿 목록 -->
      <el-col :span="12" class="mr-r20">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div class="vertical-center-box">
            <div class="title-h3 mr-r15">{{title}}</div>
            <div class="setting-addel mr-r4">
              <el-button size="mini" @click="onClickAddButton('trigger')"><i class="fas fa-plus"></i></el-button>
              <el-button size="mini" :disabled="!checkedRows.trigger.length" @click="onClickDeleteButton('trigger')"><i class="fas fa-minus"></i></el-button>
            </div>
            <el-button :disabled="!checkedRows.trigger.length" @click="onCopyButtonClick">복사</el-button>
          </div>
          <div class="vertical-center-box" align="right">
            <w-header-search-button size="mini" @click="showTriggerSearchTool = !showTriggerSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper ref="triggerTable" :column-default="columnDefault" :data="triggerData" :columns="tableColumns.trigger"
        :show-search-tool="showTriggerSearchTool" :show-custom-header="true" row-class-name="c-dblclick" remote pagination :total="total.trigger"
        @row-dblclick="onRowDblClick('trigger', ...arguments)" @selection-change="onSelectionChange('trigger', ...arguments)" @condition-change="loadData('trigger')">
          <template slot-scope="scope" slot="detail-slot">
            <span><i class="far fa-search-plus c-pointer" @click.stop="onClickDetailButton('trigger', scope.row)"></i></span>
          </template>
        </el-table-wrapper>
      </el-col>
      <!-- 작업 목록 -->
      <el-col :span="12">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div class="vertical-center-box">
            <div class="title-h3 mr-r15">[{{ selectedTriggerName }}] 작업 목록</div>
            <div class="setting-addel">
              <el-button size="mini" :disabled="trgJobAddDisabled" @click="onClickAddButton('trgJob')"><i class="fas fa-plus"></i></el-button>
              <el-button size="mini" :disabled="!checkedRows.trgJob.length" @click="onClickDeleteButton('trgJob')"><i class="fas fa-minus"></i></el-button>
            </div>
          </div>
          <div class="vertical-center-box" align="right">
            <el-button class="mr-r4" :disabled="trgJobAddDisabled" @click="onClickExcelImport">
              <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
              <span style="left:2px;bottom:5px;">  엑셀입력</span>
            </el-button>
            <w-header-search-button size="mini" @click="showTrgJobSearchTool = !showTrgJobSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper ref="trgJobTable" :column-default="columnDefault" :data="trgJobData" :columns="tableColumns.trgJob"
        :show-search-tool="showTrgJobSearchTool" :show-custom-header="true" row-class-name="c-dblclick" remote pagination :total="total.trgJob"
        @row-dblclick="onRowDblClick('trgJob', ...arguments)" @selection-change="onSelectionChange('trgJob', ...arguments)" @condition-change="loadData('trgJob')">
          <template slot-scope="scope" slot="command-slot">
            <span><i class="far fa-search-plus c-pointer" @click.stop="onClickCommandButton(scope.row)"></i></span>
          </template>
          <template slot-scope="scope" slot="detail-slot">
            <span><i class="far fa-search-plus c-pointer" @click.stop="onClickDetailButton('trgJob', scope.row)"></i></span>
          </template>
        </el-table-wrapper>
      </el-col>
    </el-row>
    <!-- 템플릿 추가/수정 팝업 -->
    <w-trigger-setting-popup :selected-group="selectedGroupData" :selected-trigger="popupParams.trigger" @re-load="loadData('trigger')" ref="triggerSettingPopup" />
    <!-- 작업 추가/수정 팝업 -->
    <w-trigger-job-setting-popup :work-count-info="workCountInfo" :selected-trigger="selectedTrigger" :selected-job="popupParams.trgJob" @re-load="loadData('trgJob')" ref="trgJobSettingPopup" />
    <!-- 수행 커맨드 팝업 -->
    <w-trigger-exec-command-popup :selected-trg-job="popupParams.trgJob" ref="execCommandPopup" />
    <!-- 템플릿 노드/변수 설정 팝업 -->
    <w-trigger-node-setting-popup :selected-trigger="selectedTrigger" :selected-trg-job="selectedTrgJob" @re-load="loadData" ref="triggerNodeSettingPopup" />
    <!-- 템플릿 변수 값 엑셀 입력 팝업 -->
    <w-trigger-var-value-excel-import-popup :selected-trigger="selectedTrigger" @re-load="loadData('trgJob')" ref="excelImportPopup" />
  </div>
</template>

<script>
import { isNil, isEmpty, camelCase } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import { getDateToString } from '@/utils/date';
import { columnDefault, defaultDetailHeaderColumn } from '@/constants/table';
import amsSettingsApi from '@/api/settings/server/ams-settings';
import WTriggerSettingPopup from '../popup/TriggerSettingPopup';
import WTriggerJobSettingPopup from '../popup/TriggerJobSettingPopup';
import WTriggerExecCommandPopup from '../popup/TriggerExecCommandPopup';
import WTriggerNodeSettingPopup from '../popup/TriggerNodeSettingPopup';
import WTriggerVarValueExcelImportPopup from '../popup/TriggerVarValueExcelImportPopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);
const dateFormatter = (row, column, value) => (isNil(value) ? EMPTY_TEXT : getDateToString(value));

export default {
  name: 'WTriggerListView',
  components: {
    WTriggerSettingPopup,
    WTriggerJobSettingPopup,
    WTriggerExecCommandPopup,
    WTriggerNodeSettingPopup,
    WTriggerVarValueExcelImportPopup,
  },
  props: {
    selectedGroupData: {
      type: Object,
    },
  },
  data() {
    return {
      EMPTY_TEXT,
      columnDefault,
      workCountInfo: 0,
      total: { trigger: 0, trgJob: 0 },
      showTriggerSearchTool: false,
      showTrgJobSearchTool: false,
      trgJobAddDisabled: true,
      tableColumns: {
        trigger: [
          { type: 'selection' },
          { prop: 'grpName', label: '템플릿 그룹 이름', width: 150, searchable: true, sortable: true, remoteProp: 'grp.grp_name' },
          { prop: 'triggerName', label: '템플릿 이름', searchable: true, sortable: true, remoteProp: 'trg.trigger_name', formatter: defaultFormatter },
          { prop: 'creatorId', label: '생성자', width: 100, searchable: true, sortable: true, remoteProp: 'trg.creator_id', formatter: defaultFormatter },
          { prop: 'createDatetime', label: '생성일시', width: 130, searchable: true, sortable: true, searchType: 'date', remoteProp: 'trg.create_datetime', formatter: dateFormatter },
          { ...defaultDetailHeaderColumn, scopedSlot: 'detail-slot' },
        ],
        trgJob: [
          { type: 'selection' },
          { prop: 'jobName', label: '작업 이름', searchable: true, sortable: true, remoteProp: 'job.job_name', formatter: defaultFormatter },
          { prop: 'failover', label: '실패 제어', width: 100, searchable: true, sortable: true, remoteProp: 'trgJob.failover', formatter: defaultFormatter },
          { prop: 'executeIndex', label: '수행 순서', width: 80, sortable: true, remoteProp: 'trgJob.execute_index', formatter: defaultFormatter },
          // { ...defaultDetailHeaderColumn, scopedSlot: 'command-slot', label: '수행 커맨드', width: 100 }, // TODO db에 수행커맨드 추가되면 구현 진행
          { ...defaultDetailHeaderColumn, scopedSlot: 'detail-slot', label: '노드 보기' },
        ],
      },
      triggerData: [],
      trgJobData: [],
      checkedRows: { trigger: [], trgJob: [] },
      popupParams: { trigger: null, trgJob: null }, // 추가/수정 팝업에 사용되는 params
      selectedTrigger: null, // 템플릿 목록에서 선택한 템플릿
      selectedTrgJob: {},
    };
  },
  computed: {
    title() {
      const title = '템플릿 목록';
      return isNil(this.selectedGroupData) || isNil(this.selectedGroupData.grpName) ? title : `[${this.selectedGroupData.grpName}] ${title}`;
    },
    selectedTriggerName() {
      return isEmpty(this.selectedTrigger) ? EMPTY_TEXT : this.selectedTrigger.triggerName;
    },
  },
  watch: {
    selectedTrigger(trigger) {
      this.trgJobAddDisabled = isNil(trigger);
      if (isNil(trigger)) {
        this.trgJobData = [];
        this.total.trgJob = 0;
      }
    },
    selectedGroupData() {
      this.$nextTick(() => {
        this.$refs.triggerTable.clearFilter();
        this.loadData();
      });
    },
  },
  methods: {
    loadData(targetType) {
      if (isNil(targetType) || targetType === 'trigger') {
        const params = this.$refs.triggerTable.getParameter();
        if (!isNil(this.selectedGroupData)) {
          params.grpId = this.selectedGroupData.grpId;
        }
        amsSettingsApi.getTriggerList(params).then((response) => {
          if (response.data.success) {
            this.triggerData = response.data.data;
            this.total.trigger = response.data.total;

            if (this.triggerData.length > 0) {
              const firstRow = this.triggerData[0];
              this.onClickDetailButton('trigger', firstRow);
            } else {
              this.selectedTrigger = null;
            }
          }
        });
      }
      if (targetType === 'trgJob') {
        const tableParams = this.$refs.trgJobTable.getParameter();
        amsSettingsApi.getTrgJobList({ triggerId: this.selectedTrigger.triggerId, ...tableParams }).then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            const total = response.data.total;
            this.trgJobData = result;
            if (total > 0) {
              this.workCountInfo = (result[response.data.total - 1].executeIndex) + 1;
            } else {
              this.workCountInfo = 1;
            }
            this.total.trgJob = total;
          }
        });
      }
    },
    onClickAddButton(targetType) {
      this.popupParams[targetType] = null;
      this.$nextTick(() => {
        this.$refs[`${targetType}SettingPopup`].open();
      });
    },
    onRowDblClick(targetType, row) {
      this.popupParams[targetType] = row;
      this.$nextTick(() => {
        this.$refs[`${targetType}SettingPopup`].open();
      });
    },
    onClickDetailButton(targetType, row) {
      if (targetType === 'trigger') {
        this.$refs.triggerTable.getTable().setCurrentRow(row);
        this.selectedTrigger = row;
        this.loadData('trgJob');
      } else {
        this.selectedTrgJob = row;
        this.$nextTick(() => {
          this.$refs.triggerNodeSettingPopup.open();
        });
        // this.$emit('show-trg-job-detail', row);
      }
    },
    onSelectionChange(targetType, selection) {
      this.checkedRows[targetType] = selection;
    },
    /**
     * 수행 커맨드 보기 팝업 open
     * @author jeee12
     * @return {[type]} [description]
     */
    onClickCommandButton(row) {
      this.popupParams.trgJob = row;
      this.$nextTick(() => {
        this.$refs.execCommandPopup.open();
      });
    },
    /**
     * 템플릿 또는 템플릿 작업 삭제
     * @author jeee12
     * @param  {[type]} targetType 선택한 대상 type
     * @return {[type]}            [description]
     */
    onClickDeleteButton(targetType) {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const target = targetType === 'trigger' ? '템플릿' : '작업';
        const action = msgUtil.action.DELETE;
        amsSettingsApi[camelCase(`delete_${targetType}_list`)](this.checkedRows[targetType]).then((response) => {
          if (response.data.success) {
            this.loadData(targetType);
          }
          this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }).catch(() => {});
    },
    /**
     * 템플릿 복사
     * @author jeee12
     * @return {[type]} [description]
     */
    onCopyButtonClick() {
      const target = '템플릿';
      const action = '복사';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        amsSettingsApi.copyTriggerList(this.checkedRows.trigger).then((response) => {
          if (response.data.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }).catch(() => {});
    },
    onClickExcelImport() {
      this.$nextTick(() => {
        this.$refs.excelImportPopup.open();
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TriggerSetting/components/TriggerListView.vue